import './index.css'
import 'bootstrap/dist/css/bootstrap.css'

import * as serviceWorker from './serviceWorker'
import { createRoot } from 'react-dom/client'
import AppWrapper from './AppWrapper'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { GTMProvider } from '@elgorditosalsero/react-gtm-hook'
import { CookiesProvider } from 'react-cookie'

const container = document.getElementById('root') as HTMLDivElement
const root = createRoot(container!)
const reCaptchaKey = import.meta.env.REACT_APP_GOOGLE_RECAPTCHA_KEY!
const gtmParams = {
  id: import.meta.env.REACT_APP_GTM_ID!,
  environment: {
    gtm_auth: import.meta.env.REACT_APP_GTM_AUTH!,
    gtm_preview: import.meta.env.REACT_APP_GTM_PREVIEW!,
  },
}

const app = (
  <GoogleReCaptchaProvider reCaptchaKey={reCaptchaKey} useEnterprise={true} container={{ element: 'google-ca', parameters: { theme: 'light' } }}>
    <CookiesProvider>
      <AppWrapper />
    </CookiesProvider>
  </GoogleReCaptchaProvider>
)

root.render(import.meta.env.REACT_APP_GTM_ENABLED === 'true' ? <GTMProvider state={gtmParams}>{app}</GTMProvider> : app)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
